import styled from 'styled-components';
import { defaultButton, defaultColors } from '../../../../styles/style-guide';

export const LabelSelect = styled.label<{ $labelColor?: string }>`
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: ${({ $labelColor }) => $labelColor || defaultColors.primary};
  font-weight: 600;
  letter-spacing: -0.01em;
`;

export const ButtonNext = styled.button<{ $backgroundColor?: string, $borderColor: string, $colorText?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  height: 44px;
  width: 100%;
  border-radius: 0.5rem;
  border: none;
  background-color: ${({ $backgroundColor }) => $backgroundColor || defaultButton.primary};
  padding: 0 1.5rem;
  font-size: 0.9375rem;
  line-height: 1.25rem;
  font-weight: 600;
  color: ${({ $colorText }) => $colorText };
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: all 0.15s ease;
  letter-spacing: -0.01em;
  
  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
  
  &:active:not(:disabled) {
    transform: translateY(0);
  }
  
  &:disabled {
    color: #94a3b8;
    background-color: #e2e8f0;
    cursor: not-allowed;
    box-shadow: none;
  }
`;


export const ButtonBack = styled.button<{ $backgroundColor?: string, $borderColor: string, $colorText?: string }>`
  height: 44px;
  width: 100%;
  border-radius: 0.5rem;
  border: 1px solid #e2e8f0;
  padding: 0 1.5rem;
  font-size: 0.9375rem;
  line-height: 1.25rem;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  background-color: ${defaultColors.white};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: all 0.15s ease;
  letter-spacing: -0.01em;
  
  &:hover:not(:disabled) {
    background-color: #f8fafc;
    border-color: #cbd5e1;
    color: #475569;
  }
  
  &:active:not(:disabled) {
    background-color: #f1f5f9;
  }
  
  &:disabled {
    background-color: #f5f5f5;
    color: #cbd5e1;
    cursor: not-allowed;
    box-shadow: none;
  }
`;